<template>
    <div class="thousand_layout" id="ValutBox" v-if="valutList">
        <div class="order_num text_gray">{{ $t('colon.orderNumber') }} {{ valutList.Code }}</div>
        <div class="deatil_pay_box">
            <div class="paidPay">
                <div class="text_orange">{{ GetPickupStatus[valutList.PickupStatus] }}</div>
                <template v-if="valutList.PickupStatus >= 5">
                    <br />
                    <router-link :to="{ path: `/mycardhobby/warehouse` }"><span>{{ $t('vault.ForwardtoWarehouse')
                            }}</span></router-link>

                </template>
            </div>
            <div class="steps_box">
                <div class="greed">
                    <div class="dot first">
                        <span class="yes shipped"></span>
                        <span class="dot_s"></span>
                        <span class="dot_s"></span>
                        <span class="dot_s"></span>
                    </div>
                    <div class="steps_txt">
                        {{ $t('vault.AwaitingShipment') }}
                    </div>
                </div>
                <div :class="{ 'greed': valutList.PickupStatus > 2 }">
                    <div class="dot">
                        <span class="dot_s"></span>
                        <span class="dot_s"></span>
                        <span class="yes delivery"></span>
                        <span class="dot_s"></span>
                        <span class="dot_s"></span>
                        <span class="dot_s"></span>
                    </div>
                    <div class="steps_txt">
                        {{ $t('vault.Shipped') }}
                    </div>
                </div>
                <div :class="{ 'greed': (valutList.PickupStatus == 5) }">
                    <div class="dot">
                        <span class="dot_s"></span>
                        <span class="dot_s"></span>
                        <span class="yes delivered"></span>
                    </div>
                    <div class="steps_txt">
                        {{ $t('vault.Completed') }}
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="detail_box" v-if="PostagePickup">
            <div data-v-9d030c7e="" class="detail_info">
                <div data-v-9d030c7e="" class="detail_info_box">
                    <h3 data-v-9d030c7e="">Buyer's Info</h3>
                    <div data-v-9d030c7e=""><span data-v-9d030c7e="">Nickname</span>
                        <div data-v-9d030c7e="" class="detail_msg">
                            {{ PostagePickup.ReceiverName }} ({{ PostagePickup.ReceiverPhone }})
                        </div>
                    </div>
                    <div data-v-9d030c7e=""><span data-v-9d030c7e="">Shipping address</span>
                        <div data-v-9d030c7e="" class="address_s">
                            {{ PostagePickup.ReceiverAddress }}
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div>
            <div>123123</div>
            <div>123123</div>
            <div>123123</div>
        </div> -->

        <template>
            <el-alert :title="$t('vault.thelocalwarehouse')" type="warning" show-icon :closable="false">
            </el-alert>
        </template>
        <template v-if="valutList.Remark">
            <el-alert class="vault_alert" :title="valutList.Remark" type="info" show-icon :closable="false">
            </el-alert>
        </template>

        <template v-if="TrackingList">
            <div>
                <div style="margin: 20px 0;display: flex;gap: 30px;">
                    <div>
                        <span class="text_gray">{{ $t('base.carrierName') }}:</span>{{ valutList.LogisticsCompany }}
                    </div>
                    <div>
                        <span class="text_gray">{{ $t('base.trackingNumber') }}:</span>{{ valutList.TrackingNumber }}
                    </div>
                </div>

                <div :class="{ 'steps_up': stepsUp}">
                    <div class="steps_list" v-for="(item, index) in TrackingList.TrackList" :key="index">
                        <div class="steps_list_up">
                            <span class="time">{{ setTime(item.TrackDate) }}</span>
                            <span class="dott"></span>
                            <span class="add">{{ item.TrackStatus }}</span>
                        </div>
                        <div class="steps_line"></div>
                    </div>
                </div>
                <div style="text-align: center;cursor: pointer;" @click="stepsUp = !stepsUp">{{stepsUp ? $t('base.ShowMore') : $t('base.Collapse')}}</div>
            </div>
        </template>

        <div class="table_detail_box">
            <div class="table_head BusinessType_head">
                <div class="">{{ $t('base.item') }}</div>
                <div class="">{{ $t('base.shipping') }}</div>
            </div>
            <div class="table_detail order_type" v-for="(item, index) in CardCommodities" :key="index">
                <div class="table_list_detail">
                    <div @click="getItem(item)">
                        <div class="like_box">
                            <el-image class=" like_img" :src="item.TitImg" fit="contain"></el-image>
                            <div class="like_detail">
                                <p>{{ item.Title }}</p>
                                <template v-if="item.StarCardSku && item.StarCardSku.ProfessionalGrader">
                                    <div>{{ item.StarCardSku.ProfessionalGrader }} {{ item.StarCardSku.Grade }}</div>
                                </template>
                                <div>{{ $t('vault.EstimatedValue') }}：USD {{ item.UsdPrice }}</div>
                                <div>{{ $t('vault.VaultID') }}： {{ item.Code }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>USD 0.00</div>
                </div>
            </div>
        </div>
        <vault-detail v-if="dislogType.vaultDetails" :vaultDetail="itemDetail"
            :dialogVisible='dislogType.vaultDetails' />

    </div>
</template>

<script>
// import vueVault from './js/vue-Vault.js';

import { getTime } from "@/api/public";
import VaultDetail from '@/components/dialog/vaultDetail'
export default {
    components: { VaultDetail },
    data() {

        return {
            TrackingList: '',
            dislogType: this.$enumInfo.dislogType,
            valutList: '',
            PostagePickup: '',
            CardCommodities: '',
            itemDetail: '',
            stepsUp:true
            
        }
    },
    watch: {
    },
    created: function () {
        var that = this;
        that.getPickupApply()


    },
    mounted: function () {
        var that = this;
    },
    computed: {
        setTime() {
            return function (val) {
                return getTime(val, -8, '', 'cn')
            }
        },
        GetPickupStatus() {
            return {
                2: this.$t('vault.AwaitingShipment'),
                3: this.$t('vault.Shipped'),
                5: this.$t('vault.Completed')
            }
        }
    },
    methods: {
        getItem(obj) {
            const that = this;
            that.itemDetail = obj
            that.dislogType.vaultDetails = true
        },
        getExpress(obj) {
            const that = this;
            var _data = {
                OrderCode: obj._id,
                ShipperCode: obj.LogisticsCompanyCode, //公司编号
                LogisticCode: obj.TrackingNumber //公司编号
            }
            that.$post(that.$interface.GetExpressSubscribeInfo, _data).then(res => {
                if (res.Result == 1) {
                    that.TrackingList = res.Data[0].Tracklist
                }
            })
        },
        //出库列表
        getPickupApply() {
            const that = this;
            var parm = { Id: that.$route.params.id }
            that.$post(this.$interface.GetPickupApplyById, parm).then(res => {
                if (res.Result > 0) {
                    that.valutList = res.Data;
                    that.CardCommodities = res.Data.CardCommodities;
                    that.PostagePickup = res.Data.PostagePickup
                    if (res.Data.PickupStatus >= 3) {
                       // that.getExpress(that.valutList)
                    }
                } else {
                    that.isCount = true

                }
            })

        },





    },
    destroyed: function () {
        var that = this;
    }
};
</script>


<style scoped>
/* @import "../../../static/css/vault/bootstrap.css";
@import "../../../static/css/vault/new_card.css"; */

@import "../../../static/css/orderdetail.css";
@import "../../../static/css/vault/vault.css";

.table_detail_box>div {

    display: grid;
    grid-template-columns: auto 14%;
    gap: 2%;
    text-align: center;
}

.table_list_detail {
    text-align: left;
}

.like_box {
    width: 100%;
}

.like_detail {
    width: auto;
    flex: 1;

}

.like_detail>p {
    font-weight: 700;
}

.vault_alert {
    margin: 10px 0;
}
.steps_up{
    max-height: 170px;
    overflow: hidden;
}

/* @import "../../../static/css/vault/countdown.css"; */

/* @import "../../../static/css/vault/jqzoom.css"; */
</style>


// WEBPACK FOOTER //
// src/pages/Vault/VaultOutboundDetail.vue